export function formatMoneyFromCents(
  amountCents: number | null | undefined,
  currency?: string | null,
): string {
  if (amountCents == null || Number.isNaN(amountCents as number)) return '-'
  const code = (currency || 'BRL').toUpperCase()
  const value = Number(amountCents || 0) / 100
  try {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: code as any }).format(value)
  } catch {
    return `R$ ${value.toFixed(2)}`
  }
}

export function parseBrlToCents(input: string): number {
  const raw = String(input || '').trim()
  if (!raw) return 0
  const normalized = raw.replace(',', '.')
  const v = Number(normalized)
  if (!Number.isFinite(v)) return 0
  return Math.max(0, Math.round(v * 100))
}

export function centsToBrlInput(amountCents: number | null | undefined): string {
  const v = Number(amountCents || 0)
  if (!Number.isFinite(v)) return '0.00'
  return (v / 100).toFixed(2)
}

